// extracted by mini-css-extract-plugin
module.exports = {"textBtn":"textbutton_textBtn__2Hx0f"};